module.exports = __webpack_public_path__ + "static/media/alert-triangle.66dd7ab7.svg";